module.exports = __webpack_public_path__ + "img/BlinkArt_Sword7_Blue.5067f0c5.png";